/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-06-29 16:27:26
 * @LastEditTime: 2022-10-16 23:21:16
 * @LastEditors: chenguobiao
 */
export const USER_INFO = '__USER_INFO__'
export const USER_Type = '__USER_Type__'
export const UPDATE_USER_INFO = '__UPDATE_USER_INFO__'
export const LOGIN_INFO = '__LOGIN_INFO__'
export const USER_TOKEN = '__USER_TOKEN__'
export const Game_CountDown = '__Game_CountDown__'
export const GRADING_OVER = '__GRADING_OVER__'
export const GIVE_UP = '__GIVE_UP__'
export const ANIMATION_COUNTDOWN = '__ANIMATION_COUNTDOWN__'
export const AGREEMENT_COUNTDOWN = '__AGREEMENT_COUNTDOWN__'
export const COUNTDOWN = '__COUNTDOWN__'
export const LOGINCOUNTDOWN = '__LOGINCOUNTDOWN__' // 跳转到登录倒计时

// websocket 相关
// export const WS_URL = 'ws://wzjjac.yicp.top:32415'
export const WS_URL = 'ws://42.192.194.12:22002/'
export const WS_USER_LOGIN = 'user.login'
export const WS_AI_INIT = 'play.aiChess.init'
export const WS_AI_MOVE = 'play.aiChess.chess_move'
export const WS_AI_END = 'play.aiChess.end'
export const WS_PLAY_JOIN = 'play.chess.join'
export const WS_PLAY_READY = 'play.chess.ready'
export const WS_PLAY_MOVE = 'play.chess.chess_move'
export const WS_PLAY_END = 'play.chess.end'
export const WS_PLAY_REPENTANCE = 'play.chess.repentance'
export const WS_PLAY_DRAW = 'play.chess.draw'
export const WS_PLAY_GIVE_UP = 'play.chess.giveUp'
export const WS_PLAY_LEAVE = 'play.chess.leave'

export const WS_GAME_CONFIGS = '__WS_GAME_CONFIGS__'

export const WS_TIMEOUT = '30000'

export const CHESS_NUMERICAL_VALUE = {
  p: {
    score: 1,
    weight: 1,
  },
  n: {
    score: 3.5,
    weight: 2,
  },
  b: {
    score: 3.5,
    weight: 3,
  },
  r: {
    score: 5,
    weight: 4,
  },
  q: {
    score: 10,
    weight: 5,
  },
}

export const QUESTION_TYPE_MAPPING_TITLE = {
  national_iconic: '国际象棋战术题',
  singel_selection: '单选题',
  multi_selection: '多选题',
  true_or_false: '判断题',
  ai: '国际象棋实战对决',
}

export const SCORE_MAPPING = {
  0: '满分',
  1: '优秀',
  2: '优',
  3: '再接再厉',
}
export const START_NUMBER_MAPPING = {
  0: 5,
  1: 4,
  2: 3,
  3: 1,
}
